import { render, staticRenderFns } from "./MTableCellSpacer.vue?vue&type=template&id=80d2fdf8"
import script from "./MTableCellSpacer.vue?vue&type=script&lang=js"
export * from "./MTableCellSpacer.vue?vue&type=script&lang=js"
import style0 from "./MTableCellSpacer.vue?vue&type=style&index=0&id=80d2fdf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports